import { View } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { DataViewModel } from "./data-viewModel"
import { getAsBoolean } from "src/uicomponents/components/utilities";

export class DataView extends FormBuilderComponentView<DataViewModel>{
    GetViewUniqueId(): string {
        return "V-612E4F4B-C9AB-4BED-B15B-575CAAABA176"
    }
    loadHtml(): string {
        let element = require('./data.html').default;
        let style = require('./data.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Date(v: moment.Moment) { this._Date = v; } public get Date(): moment.Moment { return this._Date;} private _Date: moment.Moment;
    public set AllowClear(v: boolean) { this._AllowClear = v; } public get AllowClear(): boolean { return this._AllowClear;} private _AllowClear: boolean;
    public set StartWithYear(v: boolean) { this._StartWithYear = v; } public get StartWithYear(): boolean { return this._StartWithYear;} private _StartWithYear: boolean;
    public set OpenTop(v: boolean) { this._OpenTop = v; } public get OpenTop(): boolean { return this._OpenTop;} private _OpenTop: boolean;
    public set TimeSelector(v: boolean) { this._TimeSelector = getAsBoolean(v); } public get TimeSelector(): boolean { return this._TimeSelector;} private _TimeSelector: boolean;
    public set DateSelector(v: boolean) { this._DateSelector = getAsBoolean(v); } public get DateSelector(): boolean { return this._DateSelector;} private _DateSelector: boolean;
    
}
